import React, { useState, Fragment } from "react";
import Title from 'antd/es/typography/Title';
import ChineseText from 'ReusableComponents/ChineseText';
import Row from "antd/es/row/index";
import Col from "antd/es/col/index";
import cloneDeep from "lodash/cloneDeep"

const invalidStyle = {
  color: '#DB2728',
}

export default function SentenceComponent(props) {
  const {
    blanks,
    questions,
    onSetBlank,
    checkAnswer,
  } = props;
  const [valid, setValid] = useState(false)
  const [isCorrect, setIscorrect] = useState(false)
  const [values, setValues] = useState([]);
  const sentences = questions.split("<editable>");

  const validate = (value) => {
    if (!value || value.length === 0) {
      setValid(false)
    } else {
      setValid(true)
    }
  }

  const setBlank = (value, index) => {
    validate(value);
    const valuesClone = cloneDeep(values);
    valuesClone[index] = value;
    setValues(valuesClone);
    onSetBlank(valuesClone);
    const correct = blanks[index].answer.includes(value);
    setIscorrect(correct);
  }

  return (
    <Fragment>
      {
        sentences.map((sentence, index) => {
          const isLastSentence = sentences.length-1 === index;
          const blankHasIndex = blanks.length > index;
          return (
            <Row type="flex" justify="start"
                 style={{ width: "50vw", textAlign: "left", alignItems: 'baseline' }}
             >
              <Col>
                <span dangerouslySetInnerHTML={{__html: sentence}}></span>
              </Col>
              {
                !isLastSentence && blankHasIndex && 
                <Col>
                  {
                    !checkAnswer &&
                      <Title level={2}
                             editable={{ onChange: value => setBlank(value, index) }}
                      >
                        <ChineseText>{values[index]}</ChineseText>
                      </Title>
                  }
                  {
                    checkAnswer && (isCorrect && valid) &&
                      <Title level={2}
                             style={{ color: '#1C9E11' }}
                      >
                        <ChineseText>{values[index]}</ChineseText>
                      </Title>
                  }
                  {
                    checkAnswer && (!isCorrect && valid) &&
                    <Fragment>
                      <Title level={2}
                             style={{ color: '#DB2728',
                                      textDecoration: 'line-through',
                                      maxHeight: 0,
                                      display: "inline",
                                    }}
                      >
                        <ChineseText>{values[index]}</ChineseText>
                      </Title>
                      <Title level={2}
                             style={{ color: '#1C9E11',
                                      maxHeight: 0,
                                      display: "inline",
                                    }}
                      >
                        <ChineseText>{blanks[index].answer}</ChineseText>
                      </Title>
                    </Fragment>
                  }
                  {
                    checkAnswer && !valid &&
                      <Title level={2}
                             style={{ color: '#DB2728' }}
                      >
                        <ChineseText>{blanks[index].answer}</ChineseText>
                      </Title>
                  }
                </Col>
              }
            </Row>
          )
        })
      }
    </Fragment>
  );
};